'use client';

import { RecaptchaProvider } from '@/components/shared/RecaptchaProvider';
import FooterNewsletterRedesign from './FooterNewsletterRedesign';

interface Props {
    domain: string;
    companyId: string;
}

const FooterNewsletterRedesignWrapper = ({ domain, companyId }: Props) => {
    return (
        <RecaptchaProvider domain={domain}>
            <FooterNewsletterRedesign domain={domain} companyId={companyId} />
        </RecaptchaProvider>
    );
};

export default FooterNewsletterRedesignWrapper;
